/*
 * Copyright © 2025 Himitsu Lab Limited. All Rights Reserved.
 */

import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import React from 'react';
import Icon from '../Components/base/icon/icon';
import { Verified } from '../models/user.model';
import { useGetSettingValue } from '../Services/settingReducer';
import { getCurrentUser } from '../Services/userReducer';
import { useAppSelector } from '../Store/hooks';
import { useCheckUserTermsPolicyQuery } from '../Services/userPolicyAgreementsApi';
import { getToken } from '../Services/tokenReducer';



function IntroScreen() {
  const { t } = useTranslation()
  const baseImageURL = useGetSettingValue('IMAGE_URL');
  const currentUser = useAppSelector(getCurrentUser);
  const userAccessToken = useAppSelector(getToken);
  const navigate = useNavigate()

  const { data: policyAccepted = false } = useCheckUserTermsPolicyQuery(
    undefined,
    {
      skip: !currentUser || !userAccessToken,
    }
  );
  
  if (currentUser?.phoneVerified === Verified.NotComplete) {
    return <></>
  }
  
  return (
    <div className="flex flex-col md:flex-row h-full px-10 gap-x-2">
      <div
        className="overflow-hidden md:w-1/3 h-full group cursor-pointer"
        id="btn_globalTalent"  onClick={() => {
          if (policyAccepted === true) {
            navigate('/s/creator');
          } else if (policyAccepted === false) {
            navigate('/termsAndConditions');
          }
        }}>
        {/* <Link to="/termsAndConditions"> */}
          <div className="mx-auto relative h-full">
            <div className="absolute w-full h-full z-10 bg-black bg-opacity-50 group-hover:bg-BeeMG-yellow transition-colors duration-300" />

            <div
              className="bg-center bg-no-repeat bg-cover transform transition duration-200 h-full"
              style={{
                backgroundImage: `url(${baseImageURL}/shopping/beemg-experience.jpg)`,
              }}
            />

            <div
              className={`absolute w-full transition-all duration-300 text-left pl-12 xs:pl-5 z-20 
          bottom-10 group-hover:top-20 group-hover:bottom-auto`}>
              <div className="text-white group-hover:text-black group-hover:text-4xl text-3xl lg:text-4xl md:text-3xl sm:text-3xl font-bold">
                <div>{t('live')}</div>
                <div>{t('experience')}</div>
              </div>
            </div>

            <div className="absolute bottom-10 right-16 z-20 transition-opacity duration-300 flex items-center space-x-2">
              <span className="text-black text-xl md:text-2xl font-semibold opacity-0 group-hover:opacity-100 transition-opacity ">
                {t('clickToEnter')}
              </span>

              <button className="p-2">
                <Icon icon="ARROW" size="x-large" height="large" />
              </button>
            </div>
          </div>
        {/* </Link> */}
      </div>

      <div
        className="overflow-hidden md:w-1/3 h-full group"
        id="btn_globalTalent">
        {/* <Link to="/s/movies"> */}
          <div className="mx-auto relative h-full">
            <div className="absolute w-full h-full z-10 bg-black bg-opacity-50 group-hover:bg-BeeMG-yellow transition-colors duration-300" />
            <div
              className="bg-center bg-no-repeat bg-cover transform transition duration-200 h-full"
              style={{
                backgroundImage: `url(${baseImageURL}/shopping/beemg-entertainment.jpg)`,
              }}
            />

            <div
              className={`absolute w-full transition-all duration-300 text-left pl-12 xs:pl-5 z-20 
          bottom-10 group-hover:top-20 group-hover:bottom-auto`}>
              <div className="text-white group-hover:text-black group-hover:text-4xl text-3xl lg:text-4xl md:text-3xl sm:text-3xl font-bold">
                <div>{t('live')}</div>
                <div>{t('entertainment')}</div>
              </div>
            </div>

            {/* <div className="absolute bottom-10 right-16 z-20 transition-opacity duration-300 flex items-center space-x-2">
              <span className="text-black text-xl md:text-2xl font-semibold opacity-0 group-hover:opacity-100 transition-opacity ">
                {t('clickToEnter')}
              </span>

              <button className="p-2">
                <Icon icon="ARROW" size="x-large" height="large" />
              </button>
            </div> */}
            <div className="absolute bottom-10 right-16 z-20 transition-opacity duration-300 flex items-center space-x-2">
              <span className="text-black text-xl md:text-2xl font-semibold opacity-0 group-hover:opacity-100 transition-opacity">
                Coming Soon...
              </span>

              <button className="p-2 opacity-100 group-hover:opacity-0 transition-opacity duration-300">
                <Icon icon="ARROW" size="x-large" height="large" />
              </button>
            </div>
          </div>
        {/* </Link> */}
      </div>

      <div
        className="overflow-hidden md:w-1/3 h-full group"
        id="btn_globalTalent">
        {/* <Link to="/l/live-shopping"> */}
          <div className="mx-auto relative h-full">
            <div className="absolute w-full h-full z-10 bg-black bg-opacity-50 group-hover:bg-BeeMG-yellow transition-colors duration-300" />
            <div
              className="bg-center bg-no-repeat bg-cover transform transition duration-200 h-full"
              style={{
                backgroundImage: `url(${baseImageURL}/shopping/beemg-shopping.jpg)`,
              }}
            />

            <div
              className={`absolute w-full transition-all duration-300 text-left pl-12 xs:pl-5 z-20 
          bottom-10 group-hover:top-20 group-hover:bottom-auto`}>
              <div className="text-white group-hover:text-black group-hover:text-4xl text-3xl lg:text-4xl md:text-3xl sm:text-3xl font-bold">
                <div>{t('live')}</div>
                <div>{t('shopping')}</div>
              </div>
            </div>

            {/* <div className="absolute bottom-10 right-16 z-20 transition-opacity duration-300 flex items-center space-x-2">
              <span className="text-black text-xl md:text-2xl font-semibold opacity-0 group-hover:opacity-100 transition-opacity ">
                {t('clickToEnter')}
              </span>

              <button className="p-2">
                <Icon icon="ARROW" size="x-large" height="large" />
              </button>
            </div> */}
            <div className="absolute bottom-10 right-16 z-20 transition-opacity duration-300 flex items-center space-x-2">
              <span className="text-black text-xl md:text-2xl font-semibold opacity-0 group-hover:opacity-100 transition-opacity">
                Coming Soon...
              </span>

              <button className="p-2 opacity-100 group-hover:opacity-0 transition-opacity duration-300">
                <Icon icon="ARROW" size="x-large" height="large" />
              </button>
            </div>
          </div>
        {/* </Link> */}
      </div>
    </div>
  );
}

export default React.memo(IntroScreen);
